export default {
  SLOTS_FETCH_USER_REQUEST: "slots/FETCH_USER_REQUEST",
  SLOTS_FETCH_USER_SUCCESS: "slots/FETCH_USER_SUCCESS",
  SLOTS_FETCH_USER_ERROR: "slots/FETCH_USER_ERROR"
};
